import { DeleteImportBulkInput, DeleteImportInput } from '@/models/gen/graphql';

import { DeleteManifestImportBulkDocument } from '@/api/queries';
import graphApi from '@/api';

const [, runRefetchDeleteManifestImportBulk] = graphApi(DeleteManifestImportBulkDocument);

const deleteManifestImportBulk = async (importIds: string[]) => {
  const search: DeleteImportInput[] = importIds.map((id: string): DeleteImportInput => ({ id }));
  const input: DeleteImportBulkInput = {
    search,
  };

  const res = await runRefetchDeleteManifestImportBulk({ input });
  return res?.deleteImportBulk;
};

export default deleteManifestImportBulk;
